import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function ProductPage() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState("asc");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    fetch(
      `https://dbioz2ek0e.execute-api.ap-south-1.amazonaws.com/mockapi/get-products?page=${page}&limit=12&order=${order}&sort=price`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setData(data);
      });
  }, [page, order]);
  return (
    <>
      <div>
        <div style={{ display: "flex" }}>
            <h3>Sort By</h3>
          <button onClick={() => setOrder("desc")}>High to Low</button>
          <button onClick={() => setOrder("asc")}>Low to High</button>
        </div>
        <div style={{ display: "flex" }}>
                <select name="" id="" onChange={(e)=>{setFilter(e.target.value)}}>
                    <option value="all">All</option>
                    <option value="men">Men</option>
                    <option value="women">Women</option>
                    <option value="kids">Kids</option>
                    <option value="homedecor">Homedecor</option>
                </select>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: "10px",
          }}
        > {filter!="all" ? data.data?.filter((elem)=>{
            return elem.category==filter
        })
          .map((elem) => {
            return (
              <Link to={`product/${elem.id}`}>
                <div>
                  <img src={elem.image} alt="image" />
                  <h3>{elem.title}</h3>
                  <p>{elem.brand}</p>
                  <p>{elem.category}</p>
                  <p>{elem.price}</p>
                </div>
              </Link>
            );
          }): data.data?.map((elem) => {
            return (
              <Link to={`product/${elem.id}`}>
                <div>
                  <img src={elem.image} alt="image" />
                  <h3>{elem.title}</h3>
                  <p>{elem.brand}</p>
                  <p>{elem.category}</p>
                  <p>{elem.price}</p>
                </div>
              </Link>
            );
          })}
          <div style={{ display: "flex" }}>
            <button
              disabled={page == 1}
              onClick={() => {
                setPage(page - 1);
              }}
            >
              prev
            </button>
            <h3>{page}</h3>
            <button
              disabled={page == data.totalPages}
              onClick={() => {
                setPage(page + 1);
              }}
            >
              next
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductPage;
